module.exports = __webpack_public_path__ + "img/success-signature.bf10f033.svg";